import getCsrfToken from "../utils/csrf_token"

const getDeviceId = () => {
  if (typeof amplitude !== "undefined" && amplitude.getInstance() && amplitude.getInstance().options) {
    return amplitude.getInstance().options.deviceId
  } else {
    return ""
  }
}

const scribdAuthorize = (options) => {
  const params = {
    from_source: options.from_source || "/",
    initial_view: options.initial_view || "join",
    slideshow_id: options.slideshow_id,
    slideshow_key: options.slideshow_key,
    device_id: getDeviceId(),
    download: options.isDownload,
    content_gate: options.isContentGate,
  }

  const form = new FormData()

  for (let [name, value] of Object.entries(params)) {
    if (value) {
      form.append(name, value)
    }
  }

  getCsrfToken().then((token) => {
    return fetch("/scribd/authorize", {
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": token,
      },
      method: "POST",
      body: form,
    })
      .then((response) => response.json())
      .then((data) => {
        const paramsToSend = []

        for (let [name, value] of Object.entries(data.params)) {
          if (value) {
            paramsToSend.push(`${encodeURIComponent(name)}=${encodeURIComponent(value)}`)
          }
        }

        const paramString = paramsToSend.join("&")

        const urlWithParams = `${data.url}?${paramString}`

        window.location.href = urlWithParams
      })
  })
}

export default scribdAuthorize
